import React from 'react'
import SpaceTypeSelect from './SpaceTypeSelect'
import MultiSelect from './MultiSelect'
import { ISpaceType } from '@api/types'

interface MultiSpaceTypeSelectProps {
  values: ISpaceType[]
  onChange: (items: ISpaceType[]) => void
  title?: string
  buttonText?: string
  onSelectAllChange?: (items: ISpaceType[]) => void
  shouldIncludeSelectAll?: boolean
  seatableSpaceTypesOnly?: boolean
}

MultiSpaceTypeSelect.defaultProps = {
  title: 'Space Types',
  buttonText: 'Add',
  shouldIncludeSelectAll: false,
  seatableSpaceTypesOnly: false,
}

export default function MultiSpaceTypeSelect({
  values,
  onChange,
  title,
  buttonText,
  onSelectAllChange,
  shouldIncludeSelectAll,
  seatableSpaceTypesOnly,
}: MultiSpaceTypeSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title={title}
      values={values.map((v) => (
        <span key={v?.id}>{v?.displayName}</span>
      ))}
      select={
        <SpaceTypeSelect
          values={values}
          multi
          btnText={buttonText}
          shouldIncludeSelectAll={shouldIncludeSelectAll}
          seatableSpaceTypesOnly={seatableSpaceTypesOnly}
          value={null}
          itemDisabled={(item) => !!values.find(({ id }) => item?.id === id)}
          onChange={(st) => {
            values.find(({ id }) => id === st?.id)
              ? onChange(values.filter(({ id }) => id !== st?.id))
              : onChange([...values, st])
          }}
          onSelectAllChange={(st) => {
            st.length === 0 || st.length === values?.length ? onChange([]) : onChange(st)
            // onChange(st)
          }}
          {...{ buttonProps }}
        />
      }
      onRemove={(id) => onChange(values.filter((av) => av.id !== id))}
    />
  )
}
